import { call } from 'redux-saga/effects';
import { parseQueryString } from '../../../../utils/helperFunctions';
import notify from '../../../helpers/notify';
import request from '../../../helpers/request';
import { SHOW_CAMPAIGNS_INDICATORS } from '../constants';

const getCampaignIndicatorNotifier = (params, loader = false) =>
  notify({
    type: SHOW_CAMPAIGNS_INDICATORS,
    params,
    loader,
  });

function* getCampaignIndicatorAction({ params }) {
  const strQueryParams = parseQueryString(params);
  yield call(request, {
    type: SHOW_CAMPAIGNS_INDICATORS,
    method: 'get',
    endpoint: `/indicators/getCampaigns${strQueryParams}`,
  });
}

export { getCampaignIndicatorAction, getCampaignIndicatorNotifier };
